import * as DialogPrimitive from "@radix-ui/react-dialog"

import { Button } from "@/components/chadcn/Button"

type TermsAndConditionsDrawerProps = {
  open: boolean
  onClose: () => void
}

const TermsAndConditionsDrawer = ({
  open,
  onClose,
}: TermsAndConditionsDrawerProps) => (
  <DialogPrimitive.Root
    open={open}
    onOpenChange={(nextOpen) => {
      if (!nextOpen) onClose()
    }}
  >
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay className="fixed inset-0 z-40 bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
      <DialogPrimitive.Content
        className="fixed inset-x-0 bottom-0 z-50 flex h-[90vh] flex-col rounded-t-2xl bg-white shadow-lg focus:outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom"
      >
        <div className="border-b border-secondary p-4">
          <DialogPrimitive.Title className="text-lg font-bold text-primary-contrast">
            Terms and Conditions
          </DialogPrimitive.Title>
        </div>
        <div className="flex-1 overflow-hidden">
          <iframe
            src="/terms_and_conditions.html"
            title="Terms and Conditions"
            className="h-full w-full border-0"
            scrolling="yes"
          />
        </div>
        <div className="border-t border-secondary p-4 text-center">
          <Button
            type="button"
            className="min-w-[120px] py-2 text-base"
            onClick={onClose}
          >
            Close
          </Button>
        </div>
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  </DialogPrimitive.Root>
)

export default TermsAndConditionsDrawer
